/**
 * Row reducer for the CPT table's "Pending#" cell.
 * @module updateRowData/pendingNumberReducer
 */
import { CptCodeWithDetailsKeys } from "../../../../../../enums/tableColumnKeys";

/**
 * Patches the pending-number cell's `data` for a single row.
 *
 * Pending# is never required, so `hasError` stays false.
 *
 * @param rowDataToUpdate - The current row data object to clone and patch
 * @param updatedData - The new pending-number string entered in the cell
 * @return The row data with `PendingNumber.data` replaced
 */
export const updateRowDataForPendingNumber = (
  rowDataToUpdate: any,
  updatedData: any,
) => ({
  ...rowDataToUpdate,
  [CptCodeWithDetailsKeys.PendingNumber]: {
    ...rowDataToUpdate[CptCodeWithDetailsKeys.PendingNumber],
    data: updatedData,
    hasError: false,
  },
});
